/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_TaglineInputs */

const en_ui_onboarding_tagline = /** @type {(inputs: Ui_Onboarding_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your runs and rides on an interactive map.`)
};

const de_ui_onboarding_tagline = /** @type {(inputs: Ui_Onboarding_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Läufe und Radtouren auf einer interaktiven Karte.`)
};

/**
* | output |
* | --- |
* | "Your runs and rides on an interactive map." |
*
* @param {Ui_Onboarding_TaglineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_tagline = /** @type {((inputs?: Ui_Onboarding_TaglineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_TaglineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_tagline(inputs)
	return de_ui_onboarding_tagline(inputs)
});